import { uiRows } from './types-def.js';
/** `web/inbox` (1.N-1): the single triage surface. */
export const INBOX_INTERACTIONS = uiRows([
    {
        id: 'inbox.select.range',
        module: 'web/inbox',
        behavior: 'Shift-click selects a range of rows',
        owner: '1.N-1',
        since: 'exit-1b',
    },
    {
        id: 'inbox.bulk.accept',
        module: 'web/inbox',
        behavior: 'A applies the primary action to every selected row',
        owner: '1.N-1',
        since: 'exit-1b',
    },
    {
        id: 'inbox.bulk.reject',
        module: 'web/inbox',
        behavior: 'X rejects every selected row',
        owner: '1.N-1',
        since: 'exit-1b',
    },
    {
        id: 'inbox.ignore.once',
        module: 'web/inbox',
        behavior: '"Ignore" dismisses the item once',
        owner: '1.N-1',
        since: 'exit-1b',
    },
    {
        id: 'inbox.ignore.permanent',
        module: 'web/inbox',
        behavior: '"Ignore permanently" dismisses the item for good',
        owner: '1.N-1',
        since: 'exit-1b',
    },
    {
        id: 'inbox.counts.undismissed',
        module: 'web/inbox',
        behavior: 'Sidebar counts cover undismissed items only and update after each action',
        owner: '1.N-1',
        since: 'exit-1b',
    },
]);
//# sourceMappingURL=inbox.js.map